import { SET_LAYOUT } from './constants';

export const setLayout = (layout) => ({
  type: SET_LAYOUT,
  payload: layout
});
